import React from "react";
import { Button, Typography } from "@material-ui/core";
import {
  Container,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
  StatusContainer,
  StatusWrapper,
} from "./styles";
import PublishStatus from "components/PublishStatus";
import TrimmedText from "components/TrimmedText";
import SvgI24Details from "assets/icons/I24Details";
import SvgI24Edit from "assets/icons/I24Edit";
import {
  getPublishButtonIcon,
  getPublishButtonTextWithout,
} from "utils/publish";

interface Props {
  title: string;
  publishStatus: string;
  onDetailsClick?: () => void;
  onEdit?: () => void;
  onCopy?: () => void;
  onPublish?: () => void;
  onArchive?: () => void;
}

const TriviaCard = ({
  title,
  publishStatus,
  onDetailsClick,
  onEdit = () => {},
  onPublish = () => {},
}: Props) => {
  return (
    <Container>
      <DetailsContainer>
        <TextContainer>
          <TitleWrapper>
            <TrimmedText lines={1} text={title}>
              <Typography variant="h3" color="textPrimary">
                {title}
              </Typography>
            </TrimmedText>
          </TitleWrapper>
        </TextContainer>

        <BottomControlsContainer>
          <ControlWrapper>
            <Button
              startIcon={<SvgI24Details />}
              variant="text"
              color="secondary"
              onClick={onDetailsClick}
            >
              Details
            </Button>
          </ControlWrapper>
          <ControlWrapper>
            <Button
              startIcon={<SvgI24Edit />}
              variant="text"
              color="secondary"
              onClick={onEdit}
            >
              Edit
            </Button>
          </ControlWrapper>
          <ControlWrapper isPublishControl>
            <Button
              startIcon={getPublishButtonIcon(publishStatus)}
              variant="text"
              color="secondary"
              onClick={onPublish}
            >
              {getPublishButtonTextWithout(publishStatus)}
            </Button>
          </ControlWrapper>
        </BottomControlsContainer>
      </DetailsContainer>
      <StatusContainer>
        <StatusWrapper>
          <PublishStatus status={publishStatus} />
        </StatusWrapper>
      </StatusContainer>
    </Container>
  );
};

export default TriviaCard;
